import { render, staticRenderFns } from "./LogoSlider.vue?vue&type=template&id=7cee920e&scoped=true&"
import script from "./LogoSlider.vue?vue&type=script&lang=js&"
export * from "./LogoSlider.vue?vue&type=script&lang=js&"
import style0 from "./LogoSlider.vue?vue&type=style&index=0&id=7cee920e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cee920e",
  null
  
)

export default component.exports